import { useState } from 'react';

import { getContext } from '@/context';
import useMount from './useMount';

/**
 * Reactive auth state. Delegates the "signed in?" decision to the canonical
 * `isAuthorized` util (auth `id != null`, or a present Authorization header as
 * an earlier-arriving fallback), and re-derives it whenever `general.auth`
 * changes.
 */
const useAuth = () => {
  const [isAuthorized, setIsAuthorized] = useState(
    getContext().general.auth.getState().isAuthorized
  );

  useMount(() => {
    const unSubscribe = getContext().general.auth.subscribe((state) => {
      setIsAuthorized(state.isAuthorized);
    });

    return () => {
      unSubscribe?.();
    };
  });

  return { isAuthorized };
};

export default useAuth;
